<template>
  <v-tooltip
    bottom
    :disabled="!isOverflowing"
  >
    <template v-slot:activator="{ on, attrs }">
      <div
        ref="root"
        class="invoice-parameter-input w-100 d-block"
        :class="inputClass"
        v-bind="attrs"
        v-on="on"
      >
        <span ref="textEl" class="truncate">
          <slot></slot>
        </span>
      </div>
    </template>

    <span>{{ fullText }}</span>
  </v-tooltip>
</template>
<script>
export default {
  name: "InvoiceParameterLabel",
  props: {
    textLg: { type: Boolean, default: false },
    textSm: { type: Boolean, default: false },
    base: { type: Boolean, default: false },
    header: { type: Boolean, default: false },
    headerForm: { type: Boolean, default: false },
    body: { type: Boolean, default: false },
    textBold: { type: Boolean, default: false },
  },
  data() {
    return {
      isOverflowing: false,
      ro: null,
      fullText: ""
    };
  },
  computed: {
    inputClass() {
      return {
        'd-block foreground--text': this.base,
        'ui-text-sm': this.textSm,
        'ui-text-lg': this.textLg,
        'ui-text-base': !this.textLg && !this.textSm,
        'primary--text ui-text-base': this.headerForm,
        'font-weight-bold primary--text ui-text-base': this.header,
        'foreground--text ui-text-base': this.body,
        'font-weight-regular': !this.textBold,
        'font-weight-bold': this.textBold,
      };
    },
  },
  mounted() {
    this.updateFullText();

    if (typeof ResizeObserver !== "undefined") {
      this.ro = new ResizeObserver(() => this.checkOverflow());
      this.ro.observe(this.$refs.root);
    } else {
      window.addEventListener("resize", this.checkOverflow, { passive: true });
    }

    this.$nextTick(this.checkOverflow);
  },
  updated() {
    this.updateFullText();
    this.$nextTick(this.checkOverflow);
  },
  beforeDestroy() {
    if (this.ro) {
      this.ro.disconnect();
      this.ro = null;
    } else {
      window.removeEventListener("resize", this.checkOverflow);
    }
  },
  methods: {
    updateFullText() {
      const txt = this.$refs.textEl ? this.$refs.textEl.innerText : "";
      this.fullText = (txt || "").trim();
    },
    checkOverflow() {
      const el = this.$refs.textEl;
      if (!el) {
        this.isOverflowing = false;
        return;
      }
      this.isOverflowing = el.scrollWidth > el.clientWidth;
    },
  },
};
</script>

<style lang="scss">
.invoice-parameter-input {
  width: 100%;
  max-width: 100%;
  min-width: 0;
}

.truncate {
  display: block;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 100%;
}
</style>
